<template>
  <div class="w-100 mb-2">
    <table class="table table-sm">
      <tr>
        <th>{{ $t("commands.requirements.cols.col1") }}</th>
        <th>{{ $t("commands.requirements.cols.col2") }}</th>
        <th>{{ $t("commands.requirements.cols.col3") }}</th>
        <th></th>
      </tr>
      <tr v-for="(field, index) in model" :key="index">
        <template v-if="!hiddenTypes.includes(field.type)">
          <td>
            <b-form-select
              v-model="field.type"
              :options="options"
              size="sm"
              style="width: 115px"
            />
          </td>
          <!-- TODO -->
          <td v-if="field.type === 'todo'">
            <b-form-select
              v-model="field.config"
              :options="proxyModels"
              size="sm"
              style="width: 100px"
            />
          </td>
          <td v-else>
            <span style="display: block; width: 100px"></span>
          </td>
          <td>
            <b-form-checkbox
              v-model="field.multiple"
              :value="1"
              :unchecked-value="0"
              class="m-auto"
              style="width: 40px"
            />
          </td>
          <td>
            <a href="#" @click.prevent="removeField(index)" class="btn btn-sm btn-danger">
              <feather-icon icon="Trash2Icon" size="14"/>
            </a>
          </td>
        </template>
      </tr>
    </table>
    <div class="text-right">
      <a href="#" @click.prevent="addField" class="btn btn-sm btn-primary">
        <feather-icon icon="PlusIcon" size="14"/>
      </a>
    </div>
  </div>
</template>

<script>
import fields from "@/libs/CommandFields/fields";

const proxyModels = [
  {
    text: "Select a model",
    value: "-",
  },
  {
    text: "Alarm panels",
    value: "alarm_panels",
  }
];

export default {
  props: {
    value: Array | Object,
  },
  data() {
    return {
      options: [],
      proxyModels,
      hiddenTypes: ["alarm"],
    };
  },
  created() {
    const keys = Object.keys(fields);
    this.options = keys.map((k) => ({
      value: fields[k].field_name,
      text: this.$t(fields[k].name),
    }));
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    addField() {
      this.value.push({type: "cameras", multiple: 0});
    },
    removeField(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>

<style></style>
